export default __webpack_public_path__ + "static/media/image.7b76f9bd.jpg";